import { render, staticRenderFns } from "./PersonalEditLocalization.vue?vue&type=template&id=d0b978ee&scoped=true&"
import script from "./PersonalEditLocalization.vue?vue&type=script&lang=ts&"
export * from "./PersonalEditLocalization.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalEditLocalization.vue?vue&type=style&index=0&id=d0b978ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b978ee",
  null
  
)

export default component.exports